import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold text-textPrimary text-left" }, " Termo de Ciência e Concordância da Política de Responsabilidade sobre as atividades assistenciais assumidas junto à sociedade médica gestora da unidade ", -1)
const _hoisted_2 = { class: "flex flex-col text-left" }
const _hoisted_3 = {
  class: "flex text-center justify-center",
  "aria-label": "Tabs"
}
const _hoisted_4 = { class: "flex gap-4 items-center w-full border-t pt-4" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 0,
  class: "absolute left-0 bottom-full mb-2 w-56 origin-top-right rounded-md bg-white shadow-lg border border-gray-200 focus:outline-none z-20"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Exportar em .pdf", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Exportar em .jpg", -1)
const _hoisted_9 = { class: "text-left text-sm text-textPrimary" }

import { ref, defineAsyncComponent, nextTick, computed } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { mdiMenuDown } from '@mdi/js'
import { toJpeg } from 'html-to-image'
import jsPDF from 'jspdf'
import type { HandoverInviteResponse } from '@/Network/Types/Responses/HandoverInviteResponses'
import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

import PassedTabContent from './PassedTabContent.vue'
import AssumedTabContent from './AssumedTabContent.vue'

const iconColor = '#000000'

export default /*#__PURE__*/_defineComponent({
  __name: 'terms.of.use.modal',
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  historyItem: {
    type: Object as () => HandoverInviteResponse | null,
    default: null
  }
},
  emits: ["update:isOpen"],
  setup(__props, { emit }) {

const props = __props;

const pdfIcon = defineAsyncComponent(() => import('@/assets/icons/pdf.vue'))
const imageIcon = defineAsyncComponent(() => import('@/assets/icons/image.vue'))





const activeTab = ref<'passou' | 'assumiu'>('passou')

const signedDate = computed(() => {
  if (!props.historyItem?.updatedAt) {
    return 'Data não disponível'
  }
  try {
    const brasiliaTimezone = 'America/Sao_Paulo'
    const utcDate = new Date(props.historyItem.updatedAt)
    const zonedDate = utcToZonedTime(utcDate, brasiliaTimezone)
    return format(zonedDate, "dd/MM/yyyy 'às' HH:mm ('Horário de Brasília UTC-3')")
  } catch (error) {
    console.error('Erro ao formatar data:', error)
    return 'Data inválida'
  }
})

const signedByDoctorOrigin = computed(() => {
  const doctorName = props.historyItem?.doctorOrigin?.mainCrm?.name
  return doctorName || 'Médico (origem) não identificado'
})

const signedByDoctorDestiny = computed(() => {
  const doctorName = props.historyItem?.doctorDestiny?.mainCrm?.name
  return doctorName || 'Médico (destino) não identificado'
})

const currentSignerName = computed(() => {
  return activeTab.value === 'passou' ? signedByDoctorOrigin.value : signedByDoctorDestiny.value
})

const showExportMenu = ref(false)

function closeModal() {
  emit('update:isOpen', false)
}

function handleExport() {
  showExportMenu.value = !showExportMenu.value
}

const termRef = ref<HTMLElement | null>(null)

async function exportAsPdf() {
  showExportMenu.value = false
  await nextTick()
  const el = termRef.value
  if (!el) return
  const dataUrl = await toJpeg(el, {
    quality: 0.98,
    backgroundColor: '#ffffff',
    pixelRatio: Math.min(window.devicePixelRatio || 1, 2)
  })
  const img = new Image()
  img.src = dataUrl
  await img.decode().catch(() => {})
  const iw = img.naturalWidth || el.clientWidth
  const ih = img.naturalHeight || el.clientHeight
  const orientation = iw >= ih ? 'landscape' : 'portrait'
  const pdf = new jsPDF({ orientation, unit: 'px', format: [iw, ih] })
  pdf.addImage(dataUrl, 'JPEG', 0, 0, iw, ih)
  pdf.save(`termo-${new Date().toISOString().slice(0, 10)}.pdf`)
}

async function exportAsJpg() {
  showExportMenu.value = false
  await nextTick()
  const el = termRef.value
  if (!el) return
  const dataUrl = await toJpeg(el, { quality: 0.95, backgroundColor: '#fff' })
  const a = document.createElement('a')
  a.href = dataUrl
  a.download = `termo-${new Date().toISOString().slice(0, 10)}.jpg`
  a.click()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": __props.isOpen,
    onClose: closeModal,
    maxWidth: "max-w-[900px]"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", { onClick: handleExport }, [
            _createVNode(FilledButton, {
              text: "Exportar",
              width: "120px",
              height: "48px",
              class: "bg-primary30",
              "prepend-icon": _unref(mdiMenuDown)
            }, null, 8, ["prepend-icon"])
          ]),
          (showExportMenu.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    class: "flex cursor-pointer items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-100",
                    onClick: exportAsPdf
                  }, [
                    _createVNode(_unref(pdfIcon), {
                      width: "20",
                      height: "20",
                      color: iconColor
                    }),
                    _hoisted_7
                  ]),
                  _createElementVNode("a", {
                    class: "flex cursor-pointer items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-100",
                    onClick: exportAsJpg
                  }, [
                    _createVNode(_unref(imageIcon), {
                      width: "20",
                      height: "20",
                      color: iconColor
                    }),
                    _hoisted_8
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, "Assinado em " + _toDisplayString(signedDate.value), 1),
            _createElementVNode("p", null, "por " + _toDisplayString(currentSignerName.value), 1)
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("nav", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass([
                'border-b-2 w-full',
                activeTab.value === 'passou' ? 'border-[#2F7F91]' : 'border-transparent'
              ])
              }, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'passou')),
                  class: _normalizeClass([
                  'py-4 px-2 text-sm transition-colors focus:outline-none',
                  activeTab.value === 'passou'
                    ? 'text-textPrimary font-bold'
                    : 'text-gray-500 hover:text-gray-700'
                ])
                }, " Passou ", 2)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([
                'border-b-2 w-full',
                activeTab.value === 'assumiu' ? 'border-[#2F7F91]' : 'border-transparent'
              ])
              }, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'assumiu')),
                  class: _normalizeClass([
                  'py-4 px-2 text-sm transition-colors focus:outline-none',
                  activeTab.value === 'assumiu'
                    ? 'text-textPrimary font-bold'
                    : 'text-gray-500 hover:text-gray-700'
                ])
                }, " Assumiu ", 2)
              ], 2)
            ])
          ]),
          _createElementVNode("div", {
            ref_key: "termRef",
            ref: termRef,
            class: "py-6 text-sm leading-relaxed text-textPrimary"
          }, [
            (activeTab.value === 'passou')
              ? (_openBlock(), _createBlock(PassedTabContent, {
                  key: 0,
                  "current-signer-name": currentSignerName.value,
                  "signed-date": signedDate.value
                }, null, 8, ["current-signer-name", "signed-date"]))
              : _createCommentVNode("", true),
            (activeTab.value === 'assumiu')
              ? (_openBlock(), _createBlock(AssumedTabContent, {
                  key: 1,
                  "current-signer-name": currentSignerName.value,
                  "signed-date": signedDate.value
                }, null, 8, ["current-signer-name", "signed-date"]))
              : _createCommentVNode("", true)
          ], 512)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})